import VectorPrimitive from './VectorPrimitive.js';

class LandUse extends VectorPrimitive {
  constructor(options) {
    super(options);
  }

  /**
   * 获取Label
   * @override
   * @param {Cesium.Entity} entity
   * @returns {string?}
   */
  _getLabel(entity) {
    const extendedData = entity.kml?.extendedData;
    if (extendedData) {
      if (extendedData.ClassName) {
        return extendedData.ClassName.value ?? null;
      }
      if (extendedData.DLMC) {
        return extendedData.DLMC.value ?? null;
      }
    }
    return null;
  }

  /**
   * 处理DataSource
   * @override
   */
  _resolveDataSource() {
    const entities = this._dataSource.entities.values;

    const labelItems = [];

    this._resolvePolygon(entities, labelItems);

    if (labelItems.length > 0) {
      this._labelCollection = new Cesium.LabelCollection({
        blendOption: Cesium.BlendOption.OPAQUE,
      });
      for (let i = 0; i < labelItems.length; i++) {
        const labItem = labelItems[i];
        this._labelCollection.add(labItem);
      }
      this._collection.add(this._labelCollection);
    }

    this._dataSource = undefined;
  }
}

export default LandUse;
